import {
  Component,
  Renderer2,
  ViewChildren,
  QueryList,
  Input,
} from "@angular/core";
import { DomController, MenuController, Platform } from "@ionic/angular";
import { ConfigService } from "src/app/services/config/config.service";
import { getSidemenuSettings } from "./sidemenu-settings";
import { LogoutService } from "src/app/services/logout/logout.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import {
  MenuOptionModel,
  SideMenuSettings,
} from "../../interfaces/sidemenu-interface";
import { Router } from "@angular/router";
import { EventsService } from "src/app/services/event/event.service";
import { WebcontentService } from "src/app/services/webcontent/webcontent.service";
import { sortBy } from "src/app/services/codeUtils";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { SiteLocationService } from "src/app/services/site-location/site-location.service";
import { MenuStateService } from "src/app/services/menu-state/menu-state.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CommonAlertService } from "src/app/services/alert/alert.service";
import { BoydRewardsService } from "src/app/services/boyd-rewards/boyd-rewards.service";
import { ResponsibleGamingService } from "src/app/services/responsible-gaming-service/responsible-gaming.service";
import { PlayerDashboardService } from "src/app/services/player-dashboard/player-dashboard.service";
import { map, Observable } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { RoutingService } from "src/app/services/routing/routing.service";
import { SidemenuService } from "src/app/services/sidemenu/sidemenu.service";
import { ControlService } from "src/app/services/control/control.service";
import { Navigator } from "src/app/services/routing/navigator";

@UntilDestroy()
@Component({
  selector: "sidemenu",
  templateUrl: "sidemenu.html",
  styleUrls: ["./sidemenu.scss"],
})
export class SidemenuComponent {
  @ViewChildren("options") optionDivs: QueryList<any>;
  @ViewChildren("optionsLevel3") optionDivsLevel3: QueryList<any>;
  @ViewChildren("headerIconR") headerIcons: QueryList<any>;
  @ViewChildren("headerIconLevel3") headerIconsLevel3: QueryList<any>;

  @Input() menuSelected: string;

  public accordianIcon: string;
  public bonusNotificationDisplayedTimes: number = 0;
  public environmentName: string;
  public externalLinks: any = [];
  public hideBoydRewards: boolean = false;
  public hideRewards: boolean = false;
  public iosMenuStyle: string;
  public isAuthenticated: boolean = false;
  public isIOSApp: boolean = false;
  public isWithdrawEnable: boolean;
  public menuOptions: Array<MenuOptionModel>;
  public menuOptions$!: Observable<MenuOptionModel[]>;
  public menuSettings: SideMenuSettings;
  public notificationCount: number;
  public promoMenu$!: Observable<MenuOptionModel | undefined>;
  public showOpenDashboardMenuItem = true;
  public socialIcons: any = [];

  constructor(
    private appLinks: AppLinksService,
    private boydService: BoydRewardsService,
    private cashierContentService: CashierContentService,
    private cashierService: CashierService,
    private commonAlertService: CommonAlertService,
    private config: ConfigService,
    private control: ControlService,
    private domCtrl: DomController,
    private events: EventsService,
    private eventsService: EventsService,
    private logoutService: LogoutService,
    private menuCtrl: MenuController,
    private menuStateService: MenuStateService,
    private navigator: Navigator,
    private platform: Platform,
    private playerDashboardService: PlayerDashboardService,
    private renderer: Renderer2,
    private responsibleGamingProvider: ResponsibleGamingService,
    private router: Router,
    private routing: RoutingService,
    private service: SidemenuService,
    private siteLocationService: SiteLocationService,
    private userSession: UserSessionService,
    private utils: UtilsService,
    private webcontentService: WebcontentService,
  ) {
    this.notificationCount = Math.floor(Math.random() * 10);

    if (this.config.getConfig().SIDEMENU_SOCIAL_ARRAY != undefined) {
      this.socialIcons = JSON.parse(this.config.getConfig().SIDEMENU_SOCIAL_ARRAY);
    }

    if (this.config.getConfig().SIDEMENU_SHOW_OPEN_DASHBOARD === '0') {
      this.showOpenDashboardMenuItem = false;
    } else {
      this.showOpenDashboardMenuItem = true;
    }
    this.isIOSApp = this.platform.is("capacitor") && this.platform.is("ios");
  }

  ngOnInit() {
    if (this.config.getConfig().BOYD_REWARDS_HIDE === '1') {
      this.hideBoydRewards = true;
    }
    this.hideRewards = this.config.getConfig()?.FEATURE_REWARDS_HIDE === '1';
    let appMenuSelected = this.menuSelected;

    if (appMenuSelected === "right") {
      this.menuOptions$ = this.service.getSidemenuData().pipe(
        map(items =>
          items.filter(menu => menu.menuPlacement !== 'left')
        )
      );
    }
    if (appMenuSelected === "left") {
      this.promoMenu$ = this.service.getSidemenuData().pipe(
        map(items =>
          items.find(menu => menu.menuPlacement === 'left' && menu.code === 'promos')
        )
      );
    }

    this.menuSettings = getSidemenuSettings();
    this.checkAuth();

    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        this.getExternalLinks();
      });
    });


    this.getExternalLinks();

    this.userSession.getUserStatus().subscribe((userStatus) => {
      if (userStatus) this.isAuthenticated = true;
      else this.isAuthenticated = false;
    });
  }

  public getExternalLinks() {
    this.externalLinks = this.config
      .getExternalLinks()
      .payload.filter((link) => link.isHamburgerMenu == "1")
      .sort(sortBy("lobbyNavBarPosition"));
  }

  checkAuth() {
    this.userSession.sessionToken$
      .pipe(
        map(token => !!token),
        untilDestroyed(this)
      )
      .subscribe(() => {
        this.isAuthenticated = this.userSession.isAuthenticated();
      });
  }

  onCardClick(rewardsObj) {
    const starCardPage = {
      component: rewardsObj?.page,
      displayName: "Star Card",
      iconName: "",
      params: rewardsObj?.params
    }
    this.select(starCardPage);
  }

  onClickInfo() {
    const pointsConversionPage = {
      component: "PointsConversionPage",
      displayName: "How it works",
      iconName: "",
      tab: "howItWorks"
    }
    this.select(pointsConversionPage);
  }

  public launchPlayerDashboard() {
    this.playerDashboardService.setPlayerDashboardRouteSrc('side-menu');
    this.select({ component: 'PlayerDashboardComponent', displayName: "" });
  }

  public select(option: MenuOptionModel) {
    if (!!option.requiresQualification) return;
    if (option.component == "add_funds") return this.onDeposit();
    return this.navigateToAPage(option.component, option, this.menuSelected == "right" ? "main-menu" : "left-menu");
  }

  public navigateToAPage(pageName: string, params: any, menuSide): any {
    const hideBoydRewards = this.config.getConfig().BOYD_REWARDS_HIDE === '1';
    if (!!params && params.loyaltyCardCheck) {
      this.closeSidemenu(menuSide);
      this.boydService.checkConnectionToBoydCard().subscribe((res) => {
        if (!res && !hideBoydRewards) {
          return this.navigator.navigateTo("EnrollBoydRewardsComponent");
        } else {
          return this.navigator.navigateTo(pageName, {}, params, menuSide);
        }
      }).unsubscribe();
    } else if (pageName === "main-menu") {
      this.menuStateService.openSidemenu("main-menu");
    } else if (!!params && params.starRewardsCheck) {
      this.closeSidemenu(menuSide);
      this.boydService.hasRewards().subscribe((res) => {
        if (res.payload) {
          return this.navigator.navigateTo(pageName, {}, params, menuSide);
        } else {
          return this.navigator.navigateTo("RewardsConnectPage", {}, params, menuSide);
        }
      });
    }
    else {
      this.closeSidemenu(menuSide);
      return this.navigator.navigateTo(pageName, {}, params, menuSide);
    }
  }

  public openMainMenu(pageName: string, params: any, menuSide) {
    this.menuCtrl.open(pageName);
  }

  public closeSidemenu(menuSide: string) {
    return this.menuCtrl.close(menuSide);
  }

  public openWebview(link: any, code: any) {
    if (code === "promos") {
      this.closeSidemenu("secondary-menu");
      this.navigator.dismissAll('');
      this.control.setPromotionPage();
    } else {
      this.closeSidemenu("secondary-menu");
      this.webcontentService.updateWebcontentLink(link);
      this.events.publish("event:reload:externallinks");
      this.control.setCategoryForWordPressPage();
      this.routing.toWebviewTab(false, link);
    }
  }

  public openExternalLink(link: any) {
    let obj = {
      action_param: "",
      action_type: "",
      name: "",
    };

    this.eventsService.publish("searchbar:keyword:click", obj);
    this.closeSidemenu("secondary-menu");
    return this.appLinks.openExternalPage(link);
  }

  private onDeposit(): any {
    this.responsibleGamingProvider.getAllPendingLimit().subscribe(
      (response: any) => {
        if (response.payload.length !== 0) {
          this.navigator.navigateTo('LimitConfirmationComponent', { forceModal: true }, { callBackFn: () => { this.navigator.navigateTo("DepositMainComponent"); } });
        } else {
          this.closeSidemenu("main-menu");
          return this.cashierService
            .getActiveTypesCategories({ include_types: false })
            .subscribe(
              (response: any) => {
                if (response) {
                  const data = response.payload.filter(
                    (item) => item.is_default == true
                  );
                  let lastDeposit = data.length > 0 ? data[0].code : null;
                  //Apple Pay is only supported on iOS app
                  if (lastDeposit == "VVAP" && !(this.platform.is('capacitor') && this.platform.is('ios'))) {
                    lastDeposit = null;
                  }
                  const pageToRedirect =
                    this.cashierContentService.getVendorPage(lastDeposit);

                  !!pageToRedirect
                    ? this.navigator.navigateTo(
                      pageToRedirect,
                      {},
                      { navigateBackPage: "sidemenu" }
                    )
                    : this.navigator.navigateTo("DepositMainComponent", {
                      navigateBackPage: "sidemenu",
                    });
                }
              },
              (error) => this.navigator.navigateTo("DepositMainComponent")
            );
        }
      });

  }

  public toggleItemOptions(
    optionsDivElement: any,
    arrowIcon: any,
    itemsCount: number,
    level: number
  ): void {
    if (this.menuSettings.accordionMode) {
      this.collapseAllOptionsExceptToogdled(optionsDivElement, level);
      this.resetAllIconsExceptToggled(arrowIcon.el, level);
    }
    this.toggleOptionSubItems(
      optionsDivElement,
      this.itemHeight + 1,
      itemsCount
    );
    this.toggleOptionIcon(arrowIcon.el, level);
  }

  private collapseAllOptionsExceptToogdled(
    selectedOptionsContainer,
    level
  ): void {
    if (level == 2) {
      this.optionDivs.forEach((optionDiv) => {
        this.domCtrl.read(() => {
          let optionElement = optionDiv.nativeElement;
          if (
            optionElement.id !== selectedOptionsContainer.id &&
            this.subItemsAreExpanded(optionElement)
          ) {
            this.hideSubItems(optionElement);
          }
        });
      });

      return;
    }

    this.optionDivsLevel3.forEach((optionDiv) => {
      this.domCtrl.read(() => {
        let optionElement = optionDiv.nativeElement;
        if (
          optionElement.id !== selectedOptionsContainer.id &&
          this.subItemsAreExpanded(optionElement)
        ) {
          this.hideSubItems(optionElement);
        }
      });
    });

    return;
  }

  // Reset the arrow icon of all the options except the selected option
  private resetAllIconsExceptToggled(
    selectedArrowIcon: any,
    level: number
  ): void {
    if (level == 2) {
      this.headerIcons.forEach((headerIcon) => {
        this.domCtrl.read(() => {
          let iconElement = headerIcon.el;
          if (
            iconElement.id !== selectedArrowIcon.id &&
            this.iconIsRotated(iconElement)
          ) {
            this.resetExpandCollapseIcon(iconElement);
          }
        });
      });
      return;
    }

    this.headerIconsLevel3.forEach((headerIcon) => {
      this.domCtrl.read(() => {
        let iconElement = headerIcon.el;
        if (
          iconElement.id !== selectedArrowIcon.id &&
          this.iconIsExpanded(iconElement)
        ) {
          this.resetIcon(iconElement);
        }
      });
    });
    return;
  }

  private toggleOptionSubItems(
    optionsContainer: any,
    elementHeight: number,
    itemsCount: number
  ) {
    this.domCtrl.write(() => {
      this.subItemsAreExpanded(optionsContainer) ? shrink() : expand();
    });

    let shrink = () => {
      this.renderer.setStyle(optionsContainer, "height", "0px");
      this.renderer.setStyle(optionsContainer, "box-shadow", `none`);
      this.renderer.setStyle(optionsContainer, "padding-top", "0px");
      this.renderer.setStyle(optionsContainer, "padding-bottom", "0px");
    };
    let expand = () => {
      //this.renderer.setStyle(optionsContainer, 'height', `${(elementHeight * itemsCount)}px`);
      this.renderer.setStyle(optionsContainer, "height", `auto`);
    };
  }

  public get itemHeight(): number {
    if (this.platform.is("ios")) return this.menuSettings.itemHeight.ios;
    if (this.platform.is("desktop")) return this.menuSettings.itemHeight.wp;
    return this.menuSettings.itemHeight.md;
  }

  // Return true if sub items are expanded
  private subItemsAreExpanded(element: any): boolean {
    return element.style.height !== "" && element.style.height !== "0px";
  }

  // Return true if the icon is rotated
  private iconIsRotated(element: any): boolean {
    return element.classList.contains("rotate");
  }

  private iconIsExpanded(element: any): boolean {
    return element.classList.contains("switch");
  }

  // Toggle the arrow icon of the selected option
  private toggleOptionIcon(arrowIcon: any, level: number): void {
    if (level == 3) {
      this.domCtrl.write(() => {
        if (this.iconIsExpanded(arrowIcon)) {
          this.renderer.setProperty(arrowIcon, "name", "add-outline");
          this.renderer.removeClass(arrowIcon, "switch");
        } else {
          this.renderer.setProperty(arrowIcon, "name", "remove-outline");
          this.renderer.addClass(arrowIcon, "switch");
        }
      });
    } else {
      this.domCtrl.write(() => {
        this.iconIsRotated(arrowIcon)
          ? this.renderer.removeClass(arrowIcon, "rotate")
          : this.renderer.addClass(arrowIcon, "rotate");
      });
    }
  }

  // Collapse the sub items of the selected option
  private hideSubItems(optionsContainer: any): void {
    this.domCtrl.write(() => {
      this.renderer.setStyle(optionsContainer, "height", "0px");
      this.renderer.setStyle(optionsContainer, "box-shadow", "none");
    });
  }

  // Reset the arrow icon of the selected option
  private resetIcon(arrowIcon: any): void {
    this.domCtrl.write(() => {
      if (this.iconIsExpanded(arrowIcon)) {
        this.renderer.setProperty(arrowIcon, "name", "add-outline");
        this.renderer.removeClass(arrowIcon, "switch");
      } else {
        this.renderer.setProperty(arrowIcon, "name", "remove-outline");
        this.renderer.addClass(arrowIcon, "switch");
      }
    });
  }

  // Reset the arrow icon of the selected option
  private resetExpandCollapseIcon(arrowIcon: any): void {
    this.domCtrl.write(() => {
      this.renderer.removeClass(arrowIcon, "rotate");
    });
  }

  public onLogout() {
    this.menuCtrl.close();
    return this.logoutService.onLogout();
  }

  public execute(method) {
    return this[method]();
  }

  public onSocialIconClick(link) {
    return this.appLinks.openExternalPage(link);
  }

  onBoydRewardsWebsite() {
    this.appLinks.openExternalPage(
      this.config.getConfig()["FEATURE_BOYD_REWARDS_URL"]
    );
  }

  public changeState(url, stateCode) {
    this.menuCtrl.close();

    if (this.isAuthenticated) {
      this.commonAlertService.changeJurisdiction(() =>
        this.siteLocationService.changeState(url, stateCode)
      );
    } else {
      this.siteLocationService.changeState(url, stateCode);
    }
  }
}
